const normalizeText = (value: string | undefined): string | undefined => {
  const trimmedValue = value?.trim();

  return trimmedValue ? trimmedValue : undefined;
};

const siteBaseUrl = normalizeText(import.meta.env.VITE_SITE_BASE_URL) ?? 'https://readparables.com';

export const config = {
  apiBaseUrl:
    normalizeText(import.meta.env.VITE_API_BASE_URL) ?? 'https://api.readparables.com',
  appStoreUrl:
    normalizeText(import.meta.env.VITE_IOS_APP_STORE_URL) ??
    'https://apps.apple.com/app/parables-daily-bible-stories/id6761764216',
  privacyUrl: `${siteBaseUrl}/privacy`,
  termsUrl: `${siteBaseUrl}/terms`,
  supportUrl: `${siteBaseUrl}/support`,
} as const;
